// @第三方登入: 此 js 專門放置 google, FB, Line 的登入邏輯程式
import Vue from 'vue';
import axios from 'axios';
import thirdpartyLoginKey from '@/thirdpartyLoginKey.js'; // 統一賦予第三方登入註冊服務要用的應用 key 值
function getBrowser() {
  const { userAgent } = navigator;
  let browser = 'Chrome';
  if (userAgent.includes('Firefox/')) {
    browser = 'Firefox';
  } else if (userAgent.includes('Edg/')) {
    browser = 'Edg';
  } else if (userAgent.includes('Safari/')) {
    browser = 'Safari';
  }
  return browser;
}

function getOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(userAgent)) {
    return "android";
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "ios";
  }

  return "unknown";
}


export default {
  namespaced: true,
  state: {
    isLoading: false
  },
  getters: {},
  actions: {
    // 將從第三方拿到的 userId 資訊註冊給 lalepass，換到 lale token
    registerThirdParty(context, { userId, type, displayName }) {
      context.commit('IS_SHOW_LOADING', true);
      console.log('userId', userId);
      const api = `https://laleserver.lale.im/tokenPools/user/thirdparty/login`;
      const deviceId = getBrowser() + '-' + userId;

      const form = new FormData();
      const userData ={
        thirdPartyIdentifier: userId,
        loginType: type,
        displayName,
        deviceId: deviceId,
        devicePlatform: getOperatingSystem()
      };
      const jsonData = JSON.stringify(userData);
      const blobData = new Blob([jsonData], { type: 'application/json' });
      form.append('user', blobData);

      axios
        // partyType: 1 = Facebook, 2 = Google, 3 = Line, 4 = WeChat, 5 = Apple
        .post(api, form,  {
          headers: {
            'Content-Type': `multipart/form-data; boundary=${form._boundary}`
          }
        })
        .then(res => {
          console.log('將從第三方拿到的 userId 資訊註冊給 lalepass，換到 lale token', res);
          if (res.data.status === 200) {
            console.log('登入', res.data.data);
            context.commit('setUserInfo', { token: res.data.data.token }, { root: true });
            // 清除 url 上第三方所帶的 code 與 state
            location.replace(thirdpartyLoginKey.REDIRECT_URI);
            context.commit('IS_SHOW_LOADING', false);
          }
        })
        .catch(err => {
          console.error(err);
          //   context.commit('isShowLoading', false, { root: true });
        });
    },
    // 取得 Line 登入後回傳的 token
    getLineLoginToken(context, code) {
      const url = 'https://api.line.me/oauth2/v2.1/token'; // API網址, 取得Token
      const params = new URLSearchParams(); // 需使用URLSearchParams將參數append進去, 才符合API參數格式, 若直接傳入data會出錯
      const clientId = thirdpartyLoginKey.LINE_CLIENT_ID; // 開發平台對應的頻道ID
      const clientSecret = thirdpartyLoginKey.LINE_CLIENT_SECRET; // 開發平台對應的頻道Secret Code
      const redirectUri = thirdpartyLoginKey.REDIRECT_URI; // 開發平台對的的頻道所設定的Callback
      params.append('grant_type', 'authorization_code'); // 固定
      params.append('client_id', clientId);
      params.append('code', code);
      params.append('redirect_uri', redirectUri);
      params.append('client_secret', clientSecret);

      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: url,
          // API指定headers
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          data: params
        })
          .then(res => {
            console.log('LINE_GetToken', res, clientId);
            context.dispatch('getLINEUserInfo', { token: res.data.id_token, clientId: clientId }); // 取得 Token 後接著去敲下一隻 API 取得使用者資訊
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    /**
     * ========== LINE ===========
     */
    // 取得 LINE 使用者詳細資訊
    getLINEUserInfo(context, info) {
      const api = 'https://api.line.me/oauth2/v2.1/verify'; // 固定
      const params = new URLSearchParams(); // 需使用URLSearchParams將參數append進去, 才符合API參數格式, 若直接傳入data會出錯
      params.append('client_id', info.clientId); // 開發平台對應的頻道ID
      params.append('id_token', info.token); // 登入後取得Code後去敲tokenAPI後取得
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: api,
          // API指定headers
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          data: params
        })
          .then(res => {
            console.log('取得 Line 使用者詳細資訊', res);
            context.dispatch('registerThirdParty', { userId: res.data.sub, type: 3, displayName: res.data.name });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    /**
     * ========== FB ===========
     */
    // 取得 FB 使用者詳細資訊
    getFbUserInfo(context, token) {
      const api = `https://graph.facebook.com/me?fields=id,name,email,birthday&access_token=${token}`;
      return new Promise((resolve, reject) => {
        axios
          .get(api)
          .then(res => {
            console.log('取得 FB 使用者詳細資訊', res);
            context.dispatch('registerThirdParty', { userId: res.data.id, type: 1, displayName: res.data.name });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    // 取得 FB 登入後回傳的 token
    getFbLoginToken(context, code) {
      const appId = thirdpartyLoginKey.FB_APP_ID; // 在 FB開發人員後台的 應用程式編號
      const redirectUri = thirdpartyLoginKey.REDIRECT_URI; // FB 登入完後要導向哪頁
      const clientSecret = thirdpartyLoginKey.FB_CLIENT_SECRET; // 在 FB開發人員後台的 應用程式密鑰
      const api = `https://graph.facebook.com/v11.0/oauth/access_token?client_id=${appId}&redirect_uri=${redirectUri}&client_secret=${clientSecret}&code=${code}`;
      return new Promise((resolve, reject) => {
        axios
          .get(api)
          .then(res => {
            console.log('FB_GetToken', res);
            context.dispatch('getFbUserInfo', res.data.access_token); // 取得 Token 後接著去敲下一隻 API 取得使用者資訊
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  mutations: {
    IS_SHOW_LOADING(state, payload) {
      state.isLoading = payload;
    }
  }
};
